import { ArrowLeft } from 'lucide-react';
import { useNavigate, useLocation } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Sidebar } from '@/components/layout/Sidebar';
import { Header } from '@/components/layout/Header';
import { pageVariants } from '@/lib/motion';

interface Props {
  title: string;
  subtitle?: string;
  back?: string;
  maxWidth?: 'sm' | 'md' | 'lg' | 'xl' | 'full';
  children: React.ReactNode;
}

export function PageShell({ title, subtitle, back, maxWidth = 'lg', children }: Props) {
  const navigate = useNavigate();
  const location = useLocation();

  const widthClass = {
    sm:   'max-w-xl',
    md:   'max-w-3xl',
    lg:   'max-w-5xl',
    xl:   'max-w-7xl',
    full: 'max-w-none',
  }[maxWidth];

  return (
    <div className="h-full flex bg-surface">
      <Sidebar />
      <div className="flex-1 flex flex-col min-w-0">
        <Header />
        <main className="flex-1 overflow-y-auto">
          <motion.div
            key={location.pathname}
            variants={pageVariants}
            initial="initial"
            animate="animate"
            className={`px-4 lg:px-8 py-6 ${widthClass} mx-auto`}
          >
            {back && (
              <button onClick={() => navigate(back)} className="btn-ghost mb-4 -ml-1">
                <ArrowLeft className="w-4 h-4" />
                Voltar
              </button>
            )}
            <h1 className="font-display font-bold text-2xl text-ink mb-1">{title}</h1>
            {subtitle && <p className="text-sm text-ink-muted mb-6">{subtitle}</p>}
            {children}
          </motion.div>
        </main>
      </div>
    </div>
  );
}
